/* eslint-disable react-hooks/exhaustive-deps */
import { exitEditWidgetMode, saveWidget, saveWidgetCustomerConfig } from 'actions/dashboardEdit';
import FilterPills from 'components/EnvelopeList/FilterPills';
import LoadingIndicator from 'components/LoadingIndicator';
import { widgetNameMap } from 'constants/dashboard';
import DashboardEditFiltersTreeContext, {
  DashboardEditFiltersTreeProvider,
} from 'contexts/DashboardEditFiltersTreeContext';
import useAddDashboardEditTreeToStore from 'hooks/envelopes/useAddDashboardEditTreeToStore';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSaveCustomerLoading } from 'selectors/auth';
import { getUpsertDashboardLoading } from 'selectors/dashboard';
import { getDashboardState, getTree } from 'selectors/dashboardEdit';
import { useSelector } from 'store';
import { RouteParams } from 'types';
import { getAllFieldsValuesWithLabels, getNavParamsFromFilters } from 'utils/parserTree';
import GroupOptionsMenu from './GroupOptionsMenu';

const DashboardEditHeader: React.FC = () => {
  const dispatch = useDispatch();
  const { activeUuid } = useParams<{ activeUuid: string }>();

  const dashboardState = useSelector(getDashboardState(activeUuid || ''));

  // @ts-ignore
  const filterSearch = dashboardState.widgets[0].filters_search[0] || '';
  useAddDashboardEditTreeToStore(filterSearch, 0);
  const tree = useSelector((state) => getTree(state, 0));
  const treeParams = getAllFieldsValuesWithLabels(tree);

  const customerLoading = useSelector(getSaveCustomerLoading);
  const dashboardLoading = useSelector(getUpsertDashboardLoading);
  const loading = customerLoading || dashboardLoading;

  let navParams: RouteParams = {};
  navParams = getNavParamsFromFilters(filterSearch, navParams);

  if (dashboardState.primary_timezone) {
    moment.tz.setDefault(dashboardState.primary_timezone);
  }

  const widget = dashboardState.widgets[0];

  useEffect(
    () => () => {
      dispatch(exitEditWidgetMode());
    },
    []
  );

  const handleSave = (): void => {
    if (activeUuid) {
      dispatch(saveWidget({}));
    } else {
      dispatch(saveWidgetCustomerConfig({}));
    }
  };

  const handleCancel = (): void => {
    dispatch(exitEditWidgetMode());
  };

  const renderFilterPills = (): JSX.Element | null => {
    /* if (isLoading && !treeLoaded) {
      return (
        <div className="w-full flex flex-row justify-center">
          <LoadingIndicator size="10" />
        </div>
      );
    } */

    if (tree) {
      return (
        <FilterPills
          propParams={navParams}
          treePropsParams={treeParams}
          allowDelete
          envelopesPage
          customTree={tree}
          showAllFilters
          filtersModified
          treeContext={DashboardEditFiltersTreeContext}
        />
      );
    }
    return null;
  };

  return (
    <DashboardEditFiltersTreeProvider>
      <div className="pl-10 pr-6 pt-7 pb-4 flex flex-col bg-white">
        <div className="flex flex-row justify-between">
          <span className="text-heading-1">
            {widgetNameMap[widget.widget] || widget.title || widget.export_label || ''} Widget
          </span>
          <div className="flex flex-row gap-2">
            <button
              type="button"
              className="button button--secondary w-37 h-8 justify-center"
              onClick={handleCancel}
            >
              <span className="font-bold">Cancel</span>
            </button>
            <button
              type="button"
              className="button button--primary w-37 h-8 justify-center"
              onClick={handleSave}
            >
              {loading ? <LoadingIndicator size="5" /> : 'Save'}
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold">Search Query</span>
          <span className="">
            Options in the Chart and Table facets are detrermined by this query
          </span>
          <div className="flex flex-row">
            <div className="flex flex-1">{renderFilterPills()}</div>
            <div className="w-23">
              <GroupOptionsMenu treeContext={DashboardEditFiltersTreeContext} />
            </div>
          </div>
        </div>
      </div>
    </DashboardEditFiltersTreeProvider>
  );
};

export default DashboardEditHeader;
